import React from "react";
import Util from "../Util";
import { getOgImageUrl, OG_IMAGE_WIDTH, OG_IMAGE_HEIGHT, OG_IMAGE_MIME } from "./ogImageUrl";
import { buildCanonicalHref, normalizePagePath } from "./canonicalUrl";

export default function Social({
  tdk = {},
  tenant,
  lang,
  category,
  isFuture,
  resolvedUrl,
  domain = "www",
}) {
  const origin = Util.getOrigin(domain, { seo: true });
  const imageUrl = getOgImageUrl(origin);

  const canonicalUrl =
    resolvedUrl != null && resolvedUrl !== ""
      ? buildCanonicalHref({ lang, pagePath: normalizePagePath(resolvedUrl), domain })
      : null;

  const title = tdk.title || "";
  const description = tdk.description || "";

  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Spikex" />
      {canonicalUrl ? <meta property="og:url" content={canonicalUrl} /> : null}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:secure_url" content={imageUrl} />
      <meta property="og:image:type" content={OG_IMAGE_MIME} />
      <meta property="og:image:width" content={String(OG_IMAGE_WIDTH)} />
      <meta property="og:image:height" content={String(OG_IMAGE_HEIGHT)} />
      <meta property="og:image:alt" content={title} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:src" content={imageUrl} />
      <meta name="twitter:image:alt" content={title} />
    </>
  );
}
